import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { CampaignProvider, useCampaign } from "./context/CampaignContext";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Header } from "./components/Header/Header";
import { Hero } from "./components/Hero/Hero";
import { HowToParticipate } from "./components/HowToParticipate/HowToParticipate";
import { Prize } from "./components/Prize/Prize";
import { Schedule } from "./components/Schedule/Schedule";
import { FAQ } from "./components/FAQ/FAQ";
import { Regulation } from "./components/Regulation/Regulation";
import { Footer } from "./components/Footer/Footer";
import { Loader } from "./components/Loader/Loader";
import { ErrorBanner } from "./components/ErrorBanner/ErrorBanner";
import { Login } from "./components/Login/Login";
import { Results } from "./components/Results/Results";
import { useScrollReveal } from "./hooks/useScrollReveal";

function Site() {
  const { loading } = useCampaign();
  useScrollReveal(!loading);

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <Header />
      <main>
        <Hero />
        <HowToParticipate />
        <Prize />
        <Schedule />
        <FAQ />
        <Regulation />
      </main>
      <Footer />
      <ErrorBanner />
    </>
  );
}

function Home() {
  return (
    <CampaignProvider>
      <Site />
    </CampaignProvider>
  );
}

function ProtectedRoute({ children }: { children: React.ReactElement }) {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/numeros"
          element={
            <ProtectedRoute>
              <Results />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
